// extracted by mini-css-extract-plugin
export default {"spinner_container":"Loader_spinner_container__UGFc-","spinner":"Loader_spinner__lRMp+","spinner-d3wgkg":"Loader_spinner-d3wgkg__rfeNJ"};